import React from "react";
import { Link } from "react-router-dom";
import "./Laskutustiedot.css";

function Laskutustiedot() {
  return (
    <div className="laskutustiedot-page">
      <main className="laskutustiedot-content">
        <Link to="/" className="laskutustiedot-back">
          &larr; Etusivulle
        </Link>

        <h1>Laskutustiedot</h1>

        <p>
          Olemme siirtyneet ostolaskujen automaattiseen käsittelyyn ja
          toivomme, että lähetätte meille osoitetut laskut jatkossa
          ensisijaisesti verkkolaskuina. Mikäli verkkolaskutus ei ole
          mahdollista, voitte toimittaa laskut myös sähköpostitse
          PDF-muodossa. Paperilaskuja emme ota vastaan.
        </p>

        <h2>1. Verkkolaskut</h2>
        <p className="laskutustiedot-company">Mikä Homma Oy, 2891253-8</p>

        <h3>Tapa 1</h3>
        <p>
          Mikäli käytät seuraavia pankkeja palveluntarjoajana, käytä
          verkkolaskuosoitteena APIX OVT-koodia{" "}
          <span className="laskutustiedot-code">003728912538614</span> ja
          välittäjänä <span className="laskutustiedot-code">DABAFIHH</span>:
        </p>
        <ul>
          <li>Danske Bank Oyj (ent. Sampo Pankki Oyj)</li>
          <li>Handelsbanken</li>
          <li>Paikallisosuuspankit</li>
          <li>Säästöpankit</li>
          <li>Aktia Säästöpankki Oyj</li>
          <li>S-Pankki</li>
          <li>Ålandsbanken</li>
        </ul>

        <h3>Tapa 2</h3>
        <p>
          Jos käytät jotakin muuta pankkia tai verkkolaskupalvelun
          tarjoajaa, käytä verkkolaskuosoitteena{" "}
          <span className="laskutustiedot-code">003728912538614</span> ja
          operaattoritunnuksena{" "}
          <span className="laskutustiedot-code">003723327487</span> (Apix
          Messaging Oy).
        </p>

        <h2>2. Laskujen vastaanotto sähköpostitse skannauspalveluun</h2>
        <p>
          Laskut lähetetään palveluun sähköpostin PDF-muotoisina
          liitetiedostoina ja laskun liitteiden tulee olla samassa
          tiedostossa itse laskun kanssa.
        </p>

        <p>
          Sähköpostilaskun osoite:{" "}
          <a
            className="laskutustiedot-code"
            href="mailto:saapuneet.toimittajat.35830511@archive.briox.fi"
          >
            saapuneet.toimittajat.35830511@archive.briox.fi
          </a>
        </p>

        <ul>
          <li>
            Voit lähettää useita laskuja yhdessä sähköpostiviestissä, kunhan
            jokainen lasku on erillisenä liitetiedostona. Kaikilla
            tiedostoilla tulee olla eri nimi.
          </li>
          <li>Yhden sähköpostin maksimikoko on 5 Mb.</li>
          <li>
            PDF-tiedostojen tulee olla aitoja PDF-dokumentteja (PDF-versio
            1.3 tai uudempi).
          </li>
          <li>PDF-tiedostot eivät saa olla lukittuja tai salasanalla suojattuja.</li>
          <li>Dokumentin ulkomitta voi olla maksimissaan 210 x 297 mm.</li>
          <li>
            Liitteen nimen sallitut merkit ovat tavallisia kirjoitusmerkkejä,
            a-z, A-Z, 0-9. Ethän käytä erikoismerkkejä liitteiden
            nimeämiseen.
          </li>
        </ul>

        <footer className="laskutustiedot-footer">
          <small>© Mikä Homma Oy {new Date().getFullYear()}</small>
        </footer>
      </main>
    </div>
  );
}

export default Laskutustiedot;
